export const idx_data_ball_weight = [];

idx_data_ball_weight.push({
  weight: '',
});

idx_data_ball_weight.push({
  weight: '6',
});

idx_data_ball_weight.push({
  weight: '8',
});

idx_data_ball_weight.push({
  weight: '9',
});

idx_data_ball_weight.push({
  weight: '10',
});

idx_data_ball_weight.push({
  weight: '11',
});

idx_data_ball_weight.push({
  weight: '12',
});

idx_data_ball_weight.push({
  weight: '13',
});

idx_data_ball_weight.push({
  weight: '14',
});

idx_data_ball_weight.push({
  weight: '15',
});

idx_data_ball_weight.push({
  weight: '16',
});
